import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  translationSelector,
  fetchTranslationsList,
  downloadTranslationReport,
} from "slices/translationSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout/index2";
import { removeTranslation } from "slices/translationSlice";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import CotationPopup from "./CotationPopup";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import { languageSelector } from "slices/languageSlice";
import ErrorMessage from "components/common/ErrorMessage";
import { fetchLanguages } from "slices/languageSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import transicon from "../../assets/img/transicon.png";
import transicon2 from "../../assets/img/transicon2.png";
import transicon3 from "../../assets/img/transicon3.png";
import transicon4 from "../../assets/img/transicon4.png";
import { filteredStatuses } from "components/common/TableColor";
// import { fetchClients } from "slices/ClientNameSlice";
import { legends } from "components/common/TableColor";
import { fetchTranslators } from "slices/TranslatorNameSlice";
import { LegendButton } from "components/common/TableColor";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

function Translation({ item }) {
  const [cotationPopup, setCotationPopup] = React.useState({
    open: false,
    documents: [],
  });
  const dispatch = useDispatch();
  const [paginationParams, setPaginationParams] = useState({});
  const { checkPermission } = usePermissions();
  const location = useLocation();
  const {
    translations,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
    paramStatus,
  } = useSelector(translationSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });
  const refAddutton = React.useRef(null);
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10]);
  const [downloading, setDownloading] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [statusValue, setStatusValue] = useState("all");
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "name",
    sortDirection: "asc",
  });
  const { language: languages } = useSelector(languageSelector);
  // const { clients, error } = useSelector((state) => state.clients);
  const { translators } = useSelector((state) => state.translators);

  const handleAddLanguagePopUp = () => {
    setTimeout(() => {
      navigate("/translation/create");
    }, 300);
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchTranslationsList());
      hideConfirmDialog();
    } else {
      toast.error(message, {
        className: "errorToast",
      });
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return;
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  };
  const handleRemoveItems = () => {
    selectedItems.forEach((id) => {
      dispatch(removeTranslation(id, submitCallback));
    });
  };
  const handleChange = (e) => {
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item != id)
        : [...selectedItems, id]
    );
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    setSelectedItems(
      translations?.map((translation) => translation.id.toString())
    );
  };

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchTranslationsList(page));
  }, []);

  const handleClose = () => {
    refAddutton.current.click();
    setAddForm({ show: false });
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
  };


  const downloadBlobFile = (blob, filename = "appointments.xlsx") => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadReport = () => {
    setDownloading(true);


    const filters = {
      ...getValues(),
      status: statusValue
    };

    dispatch(
      downloadTranslationReport(filters, (success, res) => {
        setDownloading(false);

        if (!success) {
          Swal.fire({
            title: "Error!",
            text: (res && res.message) || "Failed to download report",
            icon: "error",
            confirmButtonColor: "#d33",
          });
          return;
        }

        try {
          // ✅ Blob file handling
          if (res instanceof Blob) {
            downloadBlobFile(res);
          } else if (res && res.blob) {
            downloadBlobFile(res.blob, res.filename || "dashboard_report.xlsx");
          } else if (typeof res === "string" && res.startsWith("data:")) {
            const arr = res.split(",");
            const mimeMatch = arr[0].match(/:(.*?);/);
            const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8 = new Uint8Array(n);
            while (n--) u8[n] = bstr.charCodeAt(n);
            const blob = new Blob([u8], { type: mime });
            downloadBlobFile(blob);
          } else if (typeof res === "string") {
            const a = document.createElement("a");
            a.href = res;
            a.target = "_blank";
            a.download = "";
            document.body.appendChild(a);
            a.click();
            a.remove();
          }

          Swal.fire({
            title: "Success!",
            text: "Report downloaded successfully.",
            icon: "success",
            confirmButtonColor: "#3085d6",
          });
        } catch (err) {
          console.error("Download error:", err);
          Swal.fire({
            title: "Error!",
            text: "Could not process downloaded file",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      })
    );
  };



  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchTranslationsList(currentPage, {
          sortBy: sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };
    return (
      <tr>
        <th className="table-col">#</th>
        <th className="table-col">TransID</th>
        <th className="table-col">Name</th>
        <th className="table-col">Target Language</th>
        <th className="table-col">Department</th>
        <th className="table-col">Translator</th>
        <th className="table-col">Status</th>
        {/* <th className="col-2">Est. Words Count</th> */}
        <th className="table-col">Due Date</th>
        <th className="table-col">Received Date</th>
        {/* {checkPermission("Edit Translations") && (
          <th className="table-col">Details</th>
        )} */}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion

  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);
  const {
    clearErrors,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    getValues,
    setError: setErrors,
    reset,
  } = useForm({
    defaultValues: {
      start_date: null,
      end_date: null,
      translator: null,
      freelancer: null,
      client: null,
      source_language: null,
      target_language: null,
    },
  });

  //#region TABLE BODY
  const renderTableContent = React.useCallback(() => {
    const safeTranslations = Array.isArray(translations?.data)
      ? translations.data
      : [];
    console.log("translation", safeTranslations);
    return safeTranslations.map((translation, index) => (
      <TranslationItem
        translation={translation}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddLanguagePopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
        onReviseQoute={() => {
          setCotationPopup({
            open: true,
            documents: translation.documents || [
              {
                name: "01091_1560_1771_1680.pdf / Afrikaans",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
              {
                name: "01091_1560_1771_1680.pdf / Berber",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
              {
                name: "01091_1560_1771_1680.pdf / Egyptian Arabic",
                wordCount: 93,
                rate: 0.13,
                formatting: 0.0,
                amount: 15.73,
              },
            ],
            transId: translation.id,
          });
        }}
      />
    ));
  }, [translations, selectedItems]);

  // #region Language dropdown
  const filteredLanguages = React.useMemo(
    () =>
      languages?.map((language) => {
        const object = {
          value: language?.id,
          label: language?.name,
        };
        return object;
      }),
    [languages]
  );

  // Source Language
  const [sourceLanguageState, setSourceLanguageState] = React.useState([]);

  React.useEffect(() => {
    const formValue = getValues("source_language_id");
    if (formValue && Array.isArray(formValue) && formValue.length > 0) {
      setSourceLanguageState(
        languages
          ?.filter((lang) => formValue.includes(lang.id))
          ?.map((val) => ({
            label: val?.name || "",
            value: val?.id || "",
          }))
      );
    }
  }, [languages, getValues]);

  // const filteredLanguagesLoadOptions = async (
  //   inputValue,
  //   loadedOptions,
  //   { page }
  // ) => {
  //   const result = await dispatch(
  //     fetchLanguages(
  //       page,
  //       {
  //         pageLength: 20,
  //         sortBy: "id",
  //         sortDirection: "asc",
  //         search: inputValue,
  //       },
  //       true,
  //       true
  //     )
  //   );
  //   return {
  //     options: result.data.map((item) => ({
  //       value: item.id,
  //       label: item.name,
  //     })),
  //     hasMore: page !== result?.last_page ? true : false,
  //     additional: {
  //       page: page + 1,
  //     },
  //   };
  // };



  const [languageState, setLanguageState] = useState({
      label: "",
      value: ""
    })
  
    useEffect(() => {
      setLanguageState(
        languages?.map(val => ({
          label: val?.language?.name || "",
          value: val?.language?.id || ""
        }))
      );
    }, [languages]);
  
  
    const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
      const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
      return {
        options: result?.data?.map(language => ({
          value: language.id,
          label: language.name,
        })),
        hasMore: page !== result?.last_page,
        additional: {
          page: page + 1,
        },
      };
    };



  // #region Target Language dropdown
  const [targetLanguageState, setTargetLanguageState] = React.useState([]);
  const [activeLegends, setActiveLegends] = useState([0]);
  const [statuses, setStatuses] = React.useState(["all"]);

  const values = getValues();

  const hanldeActiveLegend = (id, value) => {
    let updatedStatuses = [...statuses];
    let updatedIds = [...activeLegends];

    if (value === "all") {
      updatedStatuses = [];
      updatedIds = [id]; // ✅ Keep 'All' active
    } else {
      updatedStatuses = updatedStatuses.filter((s) => s !== "all");
      updatedIds = updatedIds.filter((i) => i !== 0);

      if (updatedStatuses.includes(value)) {
        updatedStatuses = updatedStatuses.filter((s) => s !== value);
        updatedIds = updatedIds.filter((i) => i !== id);
      } else {
        updatedStatuses.push(value);
        updatedIds.push(id);
      }

      // If nothing selected, fall back to 'All'
      if (updatedStatuses.length === 0) {
        updatedStatuses = [];
        updatedIds = [0]; // ✅ Reactivate 'All'
      }
    }

    setActiveLegends(updatedIds);
    setStatuses(updatedStatuses);
    setStatusValue(updatedStatuses);

    const values = getValues();
    const params = {
      start_date: values.start_date || null,
      end_date: values.end_date || null,
      status: updatedStatuses,
      translator: values.translator || values.freelancer || null,
      translation_id: values.translation_id || null,
      client: values.client || null,
      source_language: values.source_language || null,
      target_language: values.target_language || null,
    };

    Object.keys(params).forEach((key) => {
      if (params[key] === null || params[key] === "") {
        delete params[key];
      }
    });

    dispatch(fetchTranslationsList(1, params));
  };

  React.useEffect(() => {
    dispatch(fetchTranslationsList(1, values));
  }, [dispatch]);


  React.useEffect(() => {
    setTargetLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
  }, [item?.languages]);

  //#endregion

  // Translation Cards

  const renderCards = () => {
    return (
      <>
        {/* Cards Section  */}
        <div className="d-flex w-100 gap-3 interpreter_translations_boxes" style={{ marginTop: "14px" }}>
          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Total Translations</span>
              <img style={{ width: 24 }} src={transicon} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.total}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Under Review</span>
              <img style={{ width: 24 }} src={transicon2} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.under_review}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Completed</span>
              <img style={{ width: 24 }} src={transicon3} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.completed}
            </span>
          </div>

          <div
            className="border p-3 flex-fill box"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Cancelled</span>
              <img style={{ width: 24 }} src={transicon4} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {translations?.cancelled}
            </span>
          </div>
        </div>
      </>
    );
  };

  const filteredStatus = React.useMemo(() => {
    const temp_array = [...filteredStatuses];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0",
    });
    return temp_array;
  }, [filteredStatuses]);

  // React.useEffect(() => {
  //   dispatch(fetchClients()); 
  // }, [dispatch]);

  // React.useEffect(() => {
  //   dispatch(fetchTranslators()); // API call for Translators
  // }, [dispatch]);
  // React.useEffect(() => {
  //     if (location.state?.filterByToday) {
  //       const today = moment().format("YYYY-MM-DD");

  //       const params = {
  //         page: 1,
  //         start_date: today,
  //         end_date: today,
  //       };

  //       setValue("start_date", new Date());
  //       setValue("end_date", new Date());

  //       dispatch(fetchTranslationsList(1, params));
  //     }
  //   }, [location.state]);
  React.useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const startFromTomorrow = moment().add(1, "day").format("YYYY-MM-DD");
    const fourteenDaysAfter = moment().add(14, "days").format("YYYY-MM-DD");

    if (location.state?.filterByToday) {
      const params = {
        page: 1,
        start_date: today,
        end_date: today,
        exclude_declined: true,
      };

      setValue("start_date", new Date());
      setValue("end_date", new Date());

      dispatch(fetchTranslationsList(1, params));
    } else if (location.state?.filterByFourteen) {
      const params = {
        page: 1,
        start_date: startFromTomorrow,
        end_date: fourteenDaysAfter,
        exclude_declined: true,
      };

      setValue("start_date", moment().add(1, "day").toDate());
      setValue("end_date", moment().add(14, "days").toDate());

      dispatch(fetchTranslationsList(1, params));
    } else {
      dispatch(fetchTranslators());
    }
  }, [location.state]);

  // translator Option — permanent staff and freelancers get separate filters
  const toOption = (t) => ({
    value: t.id,
    label:
      (t.first_name && t.last_name)
        ? `${t.first_name} ${t.last_name}`
        : (t.first_name || t.last_name || t.name || "Unknown"),
  });

  const translatorOptions = React.useMemo(
    () =>
      translators?.data
        ?.filter((t) => t.employment_type !== "freelancer")
        .map(toOption) || [],
    [translators]
  );

  const freelancerOptions = React.useMemo(
    () =>
      translators?.data
        ?.filter((t) => t.employment_type === "freelancer")
        .map(toOption) || [],
    [translators]
  );

  const translatorLoadOptions = async (search) => {
    const q = (search || "").toLowerCase();
    const filtered = translatorOptions.filter((opt) =>
      opt.label.toLowerCase().includes(q)
    );
    return { options: filtered, hasMore: false };
  };

  const freelancerLoadOptions = async (search) => {
    const q = (search || "").toLowerCase();
    const filtered = freelancerOptions.filter((opt) =>
      opt.label.toLowerCase().includes(q)
    );
    return { options: filtered, hasMore: false };
  };

  // Client Option
  // const options = React.useMemo(
  //   () => clients?.data?.map((c) => ({ value: c.id, label: c.name })),
  //   [clients]
  // );

  // const loadOptions = async (search) => {
  //   const filtered = options.filter((opt) =>
  //     opt.label.toLowerCase().includes(search.toLowerCase())
  //   );
  //   return {
  //     options: filtered,
  //     hasMore: false,
  //   };
  // };

  // Filters onsubmit
  const onSubmit = (values) => {
    const params = {
      start_date: values.start_date
        ? moment(values.start_date).format("YYYY/MM/DD")
        : null,
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY/MM/DD")
        : null,
      translator: values.translator ?? values.freelancer ?? null,
      client: values.client ?? null,
      source_language: values.source_language ?? null,
      translation_id: values.translation_id ?? null,
      target_language: values.target_language ?? null,
      status: statusValue ?? null,
    };

    // empty values hata do
    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    // ✅ filter params state me save karo
    setPaginationParams(params);

    // ✅ aur fetch call karo
    dispatch(fetchTranslationsList(1, params));
  };
  console.log(activeLegends, 'activeLegends');

  const handleResetFields = () => {

    reset({
      start_date: null,
      end_date: null,
      client: null,
      translator: null,
      freelancer: null,
      translation_id: "",
      source_language: null,
      target_language: null,
      status: "",
    });

    setTargetLanguageState(null);
    setLanguageState([]);

    setStatuses([]);
    setStatusValue([]);
    setActiveLegends([0]);

    setSelectedItems([]);
    setSelectAll(false);
    setSearchTerm("");

    dispatch(fetchTranslationsList(1, {}));
  };

  const renderFilters = () => {
    return (
      <>
        <div className="container-fluid p-0">
          {/* Row 1 */}
          <div className="d-flex justify-content-start flex-wrap mb-4 gap-1">
            {/* Status */}
            <LegendButton
              activeIds={activeLegends}
              options={filteredStatus}
              handleClick={hanldeActiveLegend}
            />
          </div>

          {/* Row 2 */}
          <div className="row gx-4 gy-3 align-items-center">
            {/* Start Date */}
            <div className="col-12 col-md-6 col-xl-4  d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Start Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={startDateRef}
                        id="start_date"
                        type="date"
                        name="start_date"
                        placeholder="Start Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : '' // fallback current date
                        }
                        onChange={(e) => {
                          const dateString = moment(e.target.value
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* End Date */}
            <div className="col-12 col-md-6 col-xl-4  d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                End Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="end_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={endDateRef}
                        type="date"
                        name="end_date"
                        placeholder="End Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : ''
                        }
                        onChange={(e) => {
                          const dateString = moment(e.target.value
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Interpreter */}
            <div className="col-12 col-md-6 col-xl-4  d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Translator
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="translator"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={
                          field.value
                            ? translatorOptions.find(
                              (opt) =>
                                String(opt.value) === String(field.value)
                            )
                            : null
                        }
                        loadOptions={translatorLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => field.onChange(obj?.value ?? null)}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Freelancer */}
            <div className="col-12 col-md-6 col-xl-4  d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Freelancer
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="freelancer"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={
                          field.value
                            ? freelancerOptions.find(
                              (opt) =>
                                String(opt.value) === String(field.value)
                            )
                            : null
                        }
                        loadOptions={freelancerLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => field.onChange(obj?.value ?? null)}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-4  d-flex align-items-center gap-3 translation_filter_fields">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Target Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="target_language"
                  control={control}
                  defaultValue={null} 
                  render={({ field }) => (
                    <div className="basic_bases multiselect">
                      <AsyncPaginate
                        isMulti
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={languageState} 
                        loadOptions={filteredLanguagesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(selected) => {
                            setLanguageState(selected)
                            field.onChange(selected.map((opt) => opt.value))
                          }}
                        onBlur={field.onBlur}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="row-primary col-12 col-md-6 col-xl-4  d-flex align-items-center gap-3 translation_filter_fields ">
              <h2 style={{ minWidth: '120px' }}>Translation ID</h2>
              <Controller
                name="translation_id"
                control={control}
                render={({ field }) =>
                  <div className="translation input-basis basic_bases">
                    <input
                      {...field}
                      type="text"
                      className="input-in type_inp"
                      placeholder="Enter ID"
                    />
                  </div>
                }
              />
            </div>
          </div>



          {/* Buttons row */}
          <div className="d-flex justify-content-start gap-3 mt-3 w-100">
            <SubmitButton
              handleSubmit={() => handleSubmit(onSubmit)()}
              buttonType="button"
              btnText="Search"
              className={"green"}
            />
            <button
              type="button"
              className="main_button lightBlue"
              onClick={handleResetFields}
            >Reset</button>
            <button
              type="button"
              style={{ height: "fit-content", marginLeft: "auto" }}
              className="main_button"
              onClick={handleDownloadReport}
            >
              Export to Excel
            </button>
          </div>
        </div>
      </>
    );
  };

  const fetchList = React.useCallback(
    (page, params) => async (dispatch) => {
      console.log("object", statusValue);
      dispatch(fetchTranslationsList(page, { ...params }, statusValue));
    },
    [statusValue]
  );
  //#endregion

  return (
    <>
      <ListLayout
        heading="Translations"
        time={true}
        title=""
        buttonTitle="Add Translation"
        renderTableHeader={renderTableHeader}
        renderFilters={renderFilters}
        renderCards={renderCards}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        addButtonDisabled={true}
        fetchList={fetchList}
        // paginationParams={paginationParams} 
        selectedItems={selectedItems}
        handleRemoveItems={handleRemoveItems}
        renderAddForm={null}
        paginationParams={{...values,status: statuses,}}
        renderAddLink={null}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddLanguagePopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        loader={loader}
        noOfItems={total}
        disableBootstrap={true}
        searchPlaceholder="Search Translation ..."
      >
        {deleteModal && (
          <ConfirmationModal
            onClose={hideConfirmDialog}
            isOpen={deleteModal}
            onConfirm={handleRemoveItems}
          />
        )}
      </ListLayout>
      <CotationPopup
        open={cotationPopup.open}
        onClose={() => setCotationPopup({ open: false, documents: [] })}
        documents={cotationPopup.documents}
        transId={cotationPopup.transId}
      />
    </>
  );
}



const TranslationItem = ({
  translation,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  current_page,
  pageLength,
  checkPermission,
  onReviseQoute,
}) => {


  const getBackgroundStyle = (status) => {
    switch (status) {
      case "Cancelled":
      case "Client Cancelled":
      case "Quote Rejected":
        return { background: "#FFF0F0" };
      case "Submission Rejected":
        return { background: "rgb(247 197 197 / 49%)" };
      case "Under Review":
        return { background: "rgb(241 255 208 / 84%)" };
      case "New Request":
        return { background: "#FFF1D4" };
      case "Completed":
        return { background: "#D2D5D5" };
      case "Expired":
        return { background: "rgb(217 171 171)" };
      case "Quote Approved":
        return { background: "#EBFEED" };
      case "Quote Revised":
        return { background: "#f4e9ff" };
      case "Invoice Sent":
        return { background: "#DDE1FE" };
      case "Translators Invited":
        return { background: "#CBD1DC" };
      case "Assigned":
        return { background: "#f1ebff" };
      case "Pending":
        return { background: "#3176a033" };
      default:
        return { background: "#ffffff" };
    }
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  console.log('translationnnnn', translation)
  const onlyDate = new Date(translation?.created_at).toISOString().split("T")[0];
  return (
    <tr>
      <td style={getBackgroundStyle(translation?.status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission("Delete Translations") && (
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={translation.id}
                checked={selectedItems.includes(translation.id.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          )}
        </div>
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        <Link
          to={`/translation/view/${translation.id}`}
          style={{
            color: "#6F8DFF",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          {translation.transid}
        </Link>
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.requester_name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.translation_target_languages[0]?.language?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.department || 'N/A'}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.interpreter?.first_name + ' ' + translation?.interpreter?.last_name || 'N/A'}
      </td>

      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.status || 'N/A'}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation?.translation_details?.due_date || 'N/A'}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {onlyDate || 'N/A'}
      </td>
    </tr>
  );
};

export default Translation;
